export default __webpack_public_path__ + "static/media/login.e575fbd4.png";